import { KeyboardEventModifier, ScreenSpaceEventHandler, ScreenSpaceEventType } from "cesium";
import { Observable } from "rxjs";
import { DtmCesiumEvents } from "./cesium-events.model";

export class DtmCesiumPureEventObserver {
    public observer: Observable<ScreenSpaceEventHandler.MotionEvent> | undefined;

    constructor(protected event: DtmCesiumEvents, protected modifier?: KeyboardEventModifier) {}

    public init(eventsHandler: ScreenSpaceEventHandler) {
        return (this.observer = new Observable((observer) => {
            eventsHandler.setInputAction(
                (movement: ScreenSpaceEventHandler.PositionedEvent | ScreenSpaceEventHandler.MotionEvent) => {
                    {
                        if (!("position" in movement) && !("startPosition" in movement)) {
                            return observer.next(movement);
                        }

                        if ("startPosition" in movement) {
                            return observer.next({ startPosition: movement.startPosition, endPosition: movement.endPosition });
                        }

                        return observer.next({ startPosition: movement.position, endPosition: movement.position });
                    }
                },
                this.event as ScreenSpaceEventType,
                this.modifier
            );
        }));
    }
}
